import { map } from "rxjs/operators";
import { GET } from "../../module/services/fetch";

export const getConfigurationsService = () => {
  return GET("authentication/global-configurations").pipe(
    map((res: any) => res)
  );
};
